
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let Project = Parse.Object.extend('Projects');

		// Define 'Projects' scheme
		let schema = [
			'title',
			'type',
			'description',
			'location',
			'header_media',					// Pointer to "Media" object
			'start_date',
			'end_date',
			'investment_min',
			'investment_goal_min',
			'investment_goal_max',
			'funds_raised',
			'investor_count',
			'live',
			'share_price',
			'disclosure_doc',			// Pointer to "Project_Document" object
			'sections',
			'comments',
			'status',
			'allow_pledge_rewards',
			'pledge_rewards',
			'creator',
			'stripe_account_id',
			'city',
			'country',
			'postal_code',
			'region'
		];
		
		// Load schema into object prototype
		schema.forEach(function (field) {
			Object.defineProperty(Project.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return Project;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/schemas/project.schema.js